module.exports = __webpack_public_path__ + "img/ic-deals-inactive.7f9d3d02.svg";